import { Platform } from "react-native";

import * as iOS from "./SquareButton.ios";
import * as android from "./SquareButton.android";

export const { Email, Mobile, Phone, Map } = Platform.OS !== "ios" ? android : iOS;
